<div class="ninety-mobile-banner">
  <div class="ninety-mobile-banner__close" (click)="_dismiss()">
    <terra-icon icon="x" size="12" variant="bold" />
  </div>
  <div class="ninety-mobile-banner__icon">
    <terra-icon icon="90-logo" size="40" />
  </div>
  <div class="ninety-mobile-banner__content">
    <div class="ninety-mobile-banner__title">Ninety.io</div>
    <div class="ninety-mobile-banner__sub">Upgrade to our new app!</div>
  </div>
  <a class="ninety-mobile-banner__button" href="{{ _appUrl }}" target="_blank" rel="noopener" (click)="_dismiss()"
    >Get</a
  >
</div>
